var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDyooti(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 895.39 244.55",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 319.87,
    y1: 113.99,
    x2: 693.08,
    y2: 113.99,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00ff5b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0014ff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M516.46,215v1.66h7.64v5.2h-7.43v22.34h-6.49V221.84H505.6v-5.2h4.58v-1.77c0-5.82,3.48-9.61,9.92-9.61a10.41,10.41,0,0,1,5.88,1.51l-1.82,4.88a6.38,6.38,0,0,0-3.59-1.14C517.87,210.51,516.46,212,516.46,215Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555.34,216.43v27.75h-6.18v-3.53a11.34,11.34,0,0,1-8.94,3.9c-7.12,0-12-3.9-12-12.27V216.43h6.5v15c0,5,2.39,7.43,6.5,7.43,4.52,0,7.59-2.8,7.59-8.37v-14Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M580.55,242.68a10.26,10.26,0,0,1-6.23,1.87c-6.09,0-9.57-3.22-9.57-9.36V221.84h-4.57v-5.2h4.57V210.3h6.5v6.34h7.43v5.2h-7.43V235c0,2.7,1.35,4.16,3.85,4.16a5.81,5.81,0,0,0,3.63-1.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M612.78,216.43v27.75h-6.19v-3.53a11.33,11.33,0,0,1-8.94,3.9c-7.12,0-11.95-3.9-11.95-12.27V216.43h6.5v15c0,5,2.39,7.43,6.49,7.43,4.52,0,7.59-2.8,7.59-8.37v-14Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M637.36,216.12v6.18a8.54,8.54,0,0,0-1.5-.15c-4.94,0-8.06,2.91-8.06,8.57v13.46h-6.49V216.43h6.18v4.06C629.36,217.58,632.74,216.12,637.36,216.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M668.6,232.39H646.83c.78,4.05,4.15,6.65,9,6.65a9.94,9.94,0,0,0,7.53-3l3.49,4c-2.5,3-6.4,4.52-11.18,4.52-9.3,0-15.33-6-15.33-14.24s6.08-14.19,14.34-14.19,14,5.66,14,14.34C668.71,231,668.65,231.76,668.6,232.39Zm-21.83-4.32h15.75a7.55,7.55,0,0,0-7.85-6.75A7.67,7.67,0,0,0,646.77,228.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M696.46,215v1.66h7.64v5.2h-7.43v22.34h-6.49V221.84H685.6v-5.2h4.58v-1.77c0-5.82,3.48-9.61,9.92-9.61a10.41,10.41,0,0,1,5.88,1.51l-1.82,4.88a6.38,6.38,0,0,0-3.59-1.14C697.87,210.51,696.46,212,696.46,215Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M705.77,230.31c0-8.32,6.24-14.19,14.76-14.19s14.81,5.87,14.81,14.19-6.18,14.24-14.81,14.24S705.77,238.62,705.77,230.31Zm23,0c0-5.3-3.53-8.68-8.26-8.68s-8.21,3.38-8.21,8.68,3.53,8.68,8.21,8.68S728.79,235.61,728.79,230.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M757.64,216.12v6.18a8.56,8.56,0,0,0-1.51-.15c-4.93,0-8,2.91-8,8.57v13.46h-6.5V216.43h6.19v4.06C749.64,217.58,753,216.12,757.64,216.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M807.48,216.43l-10.23,27.75H791l-7.17-19.12-7.28,19.12h-6.24l-10.18-27.75h6.13l7.33,20.48,7.64-20.48h5.46L794.18,237l7.54-20.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M834.31,227.92v16.26h-6.13v-3.37c-1.56,2.39-4.58,3.74-8.74,3.74-6.34,0-10.34-3.48-10.34-8.32,0-4.62,3.12-8.26,11.54-8.26h7.17v-.42c0-3.79-2.29-6-6.91-6a13.71,13.71,0,0,0-8.42,2.75l-2.55-4.73c3-2.29,7.28-3.43,11.75-3.43C829.68,216.12,834.31,219.91,834.31,227.92Zm-6.5,7.59v-3.23h-6.7c-4.42,0-5.62,1.67-5.62,3.69,0,2.34,2,3.85,5.31,3.85C824,239.82,826.72,238.36,827.81,235.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M858.69,216.12v6.18a8.65,8.65,0,0,0-1.51-.15c-4.94,0-8.06,2.91-8.06,8.57v13.46h-6.49V216.43h6.18v4.06C850.68,217.58,854.06,216.12,858.69,216.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M891.12,205.62v38.56h-6.24V240.6a11.43,11.43,0,0,1-9.2,4c-8,0-14-5.61-14-14.24s6-14.19,14-14.19a11.38,11.38,0,0,1,8.94,3.74V205.62Zm-6.39,24.69c0-5.3-3.59-8.68-8.27-8.68s-8.26,3.38-8.26,8.68,3.59,8.68,8.26,8.68S884.73,235.61,884.73,230.31Z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 848.36,
    width: 45.44,
    height: 44.37,
    rx: 22.19
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.25,27h28.81V172.23H43.72A43.44,43.44,0,0,1,0,128.8V99.5A43.57,43.57,0,0,1,43.72,56.07h72.53Zm0,58.19H43.72A14.39,14.39,0,0,0,29.22,99.5v29.3a14.57,14.57,0,0,0,14.5,14.55h72.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.6,55.6h28.9V172.48c0,23.78-19.47,44.78-43.25,44.78H163v-28.9H263.25c8,0,14.35-7.88,14.35-15.88H205.86A42.68,42.68,0,0,1,163,129.65V55.6h28.49v74.05A14.52,14.52,0,0,0,205.86,144H277.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M368.3,55.63H478.65A43.7,43.7,0,0,1,522.3,99.27v29.44a43.57,43.57,0,0,1-43.65,43.64H368.3a43.56,43.56,0,0,1-43.65-43.64V99.27A43.7,43.7,0,0,1,368.3,55.63ZM353.75,99.27v29.44a14.76,14.76,0,0,0,14.55,14.61H478.65a14.63,14.63,0,0,0,14.55-14.61V99.27a14.45,14.45,0,0,0-14.55-14.41H368.3A14.58,14.58,0,0,0,353.75,99.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M539,55.63H649.37A43.7,43.7,0,0,1,693,99.27v29.44a43.57,43.57,0,0,1-43.65,43.64H539a43.57,43.57,0,0,1-43.65-43.64V99.27A43.7,43.7,0,0,1,539,55.63ZM524.47,99.27v29.44A14.76,14.76,0,0,0,539,143.32H649.37a14.62,14.62,0,0,0,14.55-14.61V99.27a14.44,14.44,0,0,0-14.55-14.41H539A14.58,14.58,0,0,0,524.47,99.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M740.46,55.63h70V84.32h-70V129.6A14.39,14.39,0,0,0,754.81,144h55.66v28.49H754.81a43,43,0,0,1-43.25-42.84v-101h28.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M852.34,55.63h-23.7V84.32h23.7a14.35,14.35,0,0,1,14.35,14.15v74h28.7v-74A43,43,0,0,0,852.34,55.63Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDyooti);
export default __webpack_public_path__ + "static/media/dyooti.1bbee3814d0aa73f9c25a96d4931192d.svg";
export { ForwardRef as ReactComponent };